import PromotionPoints from "components/Home/PromotionPoints";

const AcceptInstantPayPromotionDetails = () => {
  return (
    <>
      <p className={`text-navyBlue font-poppins tracking-wider text-base`}>
        Give your customers the convenience of paying for their purchases
        directly with their Open Rewards balance
      </p>
      <PromotionPoints
        heading={"Why it benefits you and your customers:"}
        points={[
          "Instead of having to first pay for their purchase and then wait for a redemption payout from us, customers will be able to pay for their purchases with you directly using their Open Rewards balance, on the spot!",
          "You will attract customers who are specifically looking for businesses that accept Instant Pay",
          "You will avoid credit card processing fees (and, better yet, you can give your customers the benefit of paying the cash total without carrying cash!)",
        ]}
      />
      <PromotionPoints
        heading={"How it works:"}
        points={[
          "Your customer will scan your business's QR code in the Open Rewards app and make a payment with their rewards balance",
          "The payment received from the customer will be deposited to your rewards fund available for immediate payout",
        ]}
      />

      <PromotionPoints
        heading={"Perks:"}
        subHeading={
          "Attract customers looking for the convenience of Instant Pay!"
        }
        points={[
          'Highlighted under the prominent "Instant Pay" filter on Discovery tab',
          "Announcement in home screen activity feed",
        ]}
      />
    </>
  );

}

export default AcceptInstantPayPromotionDetails;